import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

import { useGetCommercialMeteringPointOwnershipLastOwnershipQuery } from '@/features/commercialMeteringPointOwnerships/commercialMeteringPointOwnershipsApi';
import { CommercialMeteringPointLastOwnership } from '@/features/commercialMeteringPointOwnerships/types';

dayjs.extend(isSameOrAfter);

function hasTime(dateString: string): boolean {
  return dateString?.includes('T');
}

export const useGetCounterpartAndContractByActDate = ({
  currentActDate,
  commercialMeteringPointId,
}): CommercialMeteringPointLastOwnership => {
  const { data: commercialMeteringPointLastOwnership } =
    useGetCommercialMeteringPointOwnershipLastOwnershipQuery(
      {
        commercialMeteringPointId,
        ...(hasTime(currentActDate)
          ? { dateTime: currentActDate }
          : { date: currentActDate }),
      },
      { skip: !commercialMeteringPointId || !currentActDate },
    );

  const currentOwnership: CommercialMeteringPointLastOwnership | undefined =
    commercialMeteringPointLastOwnership;

  return currentOwnership ?? ({} as CommercialMeteringPointLastOwnership);
};
